import type { ReactNode } from 'react';

import styles from './SettingsHeading.module.css';

export interface SettingsHeadingProps {
  title: string;
  description: ReactNode;
  /** Buttons that act on the whole section, drawn on the right. */
  actions?: ReactNode;
}

export function SettingsHeading({ title, description, actions }: SettingsHeadingProps) {
  return (
    <div className={styles.heading}>
      <div className={styles.text}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
